import { MessageType } from '@/common/bot/enum';
import {
  ResolutionKind,
  ResolutionMessageType,
  ResolutionType,
} from '@/common/bot/enum/ResolutionType';
import * as Locale from '@/plugins/i18n';

type ResolutionOptionText = {
  [key in ResolutionKind]: string;
};

export const RESOLUTION_OPTIONS_TEXT: Partial<Record<
  ResolutionMessageType,
  ResolutionOptionText
>> = {
  [MessageType.RESOLUTION]: {
    [ResolutionType.YES]: Locale.i18n.t('global.yes') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.no') as string,
  },
  [MessageType.OVERLONG_AI_CONVERSATION_RESOLUTION]: {
    [ResolutionType.YES]: Locale.i18n.t('chat.sys.msg.ai.overlong_resolution.yes') as string,
    [ResolutionType.NO]: Locale.i18n.t('chat.sys.msg.ai.overlong_resolution.no') as string,
  },
};

export const RESOLUTION_OPTIONS_POSITION: Partial<Record<
  ResolutionMessageType,
  'row' | 'column'
>> = {
  [MessageType.RESOLUTION]: 'row',
  [MessageType.OVERLONG_AI_CONVERSATION_RESOLUTION]: 'column',
};
